import Image from 'next/image'
import { useEffect, useState } from 'react'
import { IoCloseOutline } from 'react-icons/io5'
import modalImg from '../assets/modal.png'

export default function Modal({ showModal, setShowModal, url, currentCard, variant, merchantName, translation, domain, countryCode }) {
    const [copied, setCopied] = useState(false)
    const logoSrc = `/logos/logo-${countryCode || 'en'}.png`;

    const close = () => {
        // Clear the hash without navigating away
        if (typeof window !== 'undefined' && window.location.hash) {
            history.replaceState(null, '', window.location.pathname + window.location.search);
        }
        setShowModal(false)
    }

    const copyDiscountCode = () => {
        if (copied) {
            navigateToAffiliate(extractGoid(currentCard.activationUrl));
        }
        else {
            navigator.clipboard.writeText(currentCard.code);
            setCopied(true)
        }
    }

    // Append ZP data blob to affiliate URL for postback tracking
    // Reads from window global set by _document.js (no cookie needed)
    // Build affiliate URL from goid + country + optional data blob
    // goid is the only thing stored in data-affiliate — full URL never appears in HTML
    const buildAffiliateUrl = (goid) => {
        const cc = window.__cc;
        const u = new URL('https://go.imp-multimedia.com/');
        u.searchParams.set('goid', goid);
        u.searchParams.set('country', cc);
        u.searchParams.set('sa', '1024');
        if (window.__dataBlob) u.searchParams.set('data', window.__dataBlob);
        return u.toString();
    }

    const navigateToAffiliate = (goid) => {
        location.href = buildAffiliateUrl(goid);
    }

    // Extract goid from a full activationUrl (used during transition for any remaining full URLs)
    const extractGoid = (url) => {
        try {
            const u = new URL(url, location.origin);
            return u.searchParams.get('goid') || '';
        } catch(e) { return ''; }
    }

    useEffect(() => {
        setCopied(false)
    }, [showModal])


    return (
        <div className={'modal ' + (showModal ? "md:flex" : "hidden")}>
            <div className='flex justify-between md:hidden bg-white py-2.5 px-3 border-b border-b-gray-450'>
                <button onClick={close} className='md:hidden text-gray-550 text-18'>
                    <IoCloseOutline />
                </button>
                <Image src={logoSrc} alt={`${domain}`} className="max-h-7" width={110} height={40} />
                <div></div>
            </div>
            {currentCard &&
                <div className='md:pt-16 pt-12 bg-gray-150 md:bg-white relative rounded-xl gap-10 flex items-center md:shadow-slider md:max-w-620 w-full h-full md:h-auto sm:p-12 p-10 flex-col md:flex-row'>
                    <div className='flex-1 flex flex-col items-center'>
                        <div className='w-full bg-white md:bg-transparent flex justify-center items-center py-5 px-10'>
                            <Image
                                src={currentCard.merchantLogo}
                                width={100}
                                height={100}
                                alt={`${currentCard.merchantName} Logo`}
                                className='md:!max-w-24 !max-w-40 !w-full !h-auto' />
                        </div>
                        <h3
                            className='md:mt-2 mt-7 text-18 font-medium text-gray-650 text-center line-clamp-2'>{currentCard.title}
                        </h3>
                        {variant = 'secondary' ? <>
                            {currentCard.code ?
                                <>
                                    <p className='btn-modal bg-gray-450 text-primary'>{currentCard.code}</p>
                                    <a
                                        href={currentCard.merchantDomain || '#'}
                                        data-affiliate={extractGoid(currentCard.activationUrl)}
                                        onClick={copyDiscountCode}
                                        className='btn-modal bg-primary text-white mt-2.5'>
                                        {copied ? translation?.copycode_button_go : translation?.copycode_button}
                                    </a>
                                </> :
                                <a href={currentCard.merchantDomain || '#'}
                                    data-affiliate={extractGoid(currentCard.activationUrl)}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigateToAffiliate(extractGoid(currentCard.activationUrl));
                                    }}
                                    className='btn-modal bg-primary text-white mt-2.5'>
                                    {translation?.offer_button}
                                </a>
                            }
                        </> : <>
                            <a href={currentCard.merchantDomain || '#'}
                                data-affiliate={extractGoid(currentCard.activationUrl)}
                                onClick={(e) => {
                                    e.preventDefault();
                                    navigateToAffiliate(extractGoid(currentCard.activationUrl));
                                }}
                                className='btn-modal bg-lime text-white' rel="nofollow">
                                {translation?.offer_button}
                            </a>
                            <a href={`https://${currentCard.merchantName}.${domain}`} className='mt-5 text-xs text-gray-medium'>{translation?.code_button} {currentCard.merchantName} {'>>'}</a>
                        </>}
                    </div>
                    <div className='flex-1'>
                        <Image
                            src={modalImg}
                            alt="img"
                            className='max-w-56 md:max-w-auto' />
                    </div>
                    <button onClick={close} className='absolute hidden md:block text-gray-550 top-5 text-2xl right-5'>
                        <IoCloseOutline />
                    </button>
                </div>}
        </div>
    )
}
